import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import colors from 'styles/colors';

const styleTxt = {
  flex: 1,
  paddingVertical: '0.7em',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
};

const styleLables = {
    fontSize: '13pt',
}

const styleContainer = {
  // Stickiness is owned by the surrounding <StickyHeader>; this bar must NOT
  // set its own `position: sticky; top: 0`, otherwise it slides to the very
  // top of the viewport and hides behind the app header (Navbar / logo bar).
  position: 'relative',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
};

type Props = {
};

type State = {
  activeTab: number,
};

class HistoryTabs extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { tabs, onClick, isSelected } = this.props;

    return (
      <View style={{ ...styleContainer }}>
        {tabs.map((title, index) => {
          const styleSel = isSelected(index) ? { color: 'white', backgroundColor: colors.evp_blue, fontWeight: 'bold' } : {};
          return (
            <TouchableOpacity
              key={index}
              style={{ ...styleTxt, ...styleSel }}
              onPress={onClick(index)}
            >
              <Text style={{...styleLables, ...styleSel}}>{title}</Text>
            </TouchableOpacity>
          );
        })}
      </View>
    );
  }
}

export default HistoryTabs;